module.exports = __webpack_public_path__ + "static/media/crfCardsAssetsLiquidation.b237eabf.svg";